module.exports = __webpack_public_path__ + "static/media/bannk.9c53b1bd.png";